var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21967 16.2197C8.92678 16.5126 8.92678 16.9874 9.21967 17.2803C9.51256 17.5732 9.98744 17.5732 10.2803 17.2803L15.2803 12.2803C15.5732 11.9874 15.5732 11.5126 15.2803 11.2197L10.2803 6.21967C9.98744 5.92678 9.51256 5.92678 9.21967 6.21967C8.92678 6.51256 8.92678 6.98744 9.21967 7.28033L13.6893 11.75L9.21967 16.2197Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPageIcon);
export default __webpack_public_path__ + "static/media/NextPageIcon.8432edaec7ee1f75fc127d23253eda3c.svg";
export { ForwardRef as ReactComponent };